import { render } from "./Adjustment.vue?vue&type=template&id=0046db8e"
import script from "./Adjustment.vue?vue&type=script&lang=js"
export * from "./Adjustment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/MAR WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__